import React, { useEffect } from "react";
import { Modal, Divider, Form, Button } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { MenuItem, Select } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import KopThermalBill from "../kot-thermal-bill";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useBilling } from "../../KOTbillingProvider";
import { v4 as uuidv4 } from "uuid";
import config from "../../../../config";
import { CircularProgress } from "@material-ui/core";
import { useKotDraft } from "../draftProvider";
import Loader from "../../../loader";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    "& legend": {
      display: "none",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
}));

const AddItemModal = ({ open, setOpen }) => {
  const classes = useStyles();
  const [form] = Form.useForm();
  const { getTotalAmount, clearAll } = useBilling();
  // const dispatch = useDispatch();
  // const draftBill = useSelector((state) => state.shopDetails.draftBill);
  const [draftBill, setDraftBill] = useKotDraft();
  const billingPayload = useSelector((state) => state.billingPayload.data);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [printerLoading, setPrinterLoading] = React.useState(false);
  const [startPrinter, setStartPrinter] = React.useState(false);

  const createKot = async (payload) => {
    return await Promise.all([
      fetch(`${config.newApiGateway}/bill/createKot`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.code === "SUCCESS") {
          setPrinterLoading(false);
          setStartPrinter(true);
          return data;
        }
        if (data.code === "ERROR") {
          setPrinterLoading(false);
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log("err".err);
      });
  };

  const handleSubmit = async (values) => {
    setPrinterLoading(true);
    setOpen(false);
    const payload = {
      shopId,
      items: addedProducts,
      totalAmount: getTotalAmount(),
      ...(billingPayload.customerName !== "" && {
        customerName: billingPayload.customerName,
      }),
      ...(billingPayload.customerName !== "" && {
        customerPhoneNumber: billingPayload.customerPhoneNumber,
      }),
      orderType: values.orderType,
      tableNumber: values.tableNo,
      waiterName: values.waiterName,
    };
    const response = await createKot(payload);
    let kotId = "";
    if (response.code === "SUCCESS") {
      kotId = response.data;
      const kotNo = document.getElementById("kotNo");
      kotNo.innerHTML = `No: ${kotId}`;
    }
    var dBill = {
      billId: uuidv4(),
      orderId: kotId,
      products: addedProducts,
      customerName: values.waiterName,
      orderType: values.orderType,
      billDate: moment().format("DD-MM-YYYY HH:mm:ss"),
      billTotal: getTotalAmount(),
      numberOfItems: addedProducts.length,
    };
    setDraftBill([...draftBill, dBill]);
  };
  const shopDetails = useSelector((state) => state.shopDetails);
  const {
    state: { addedProducts },
  } = useBilling();
  const handleClose = () => {
    form.resetFields();
    setOpen(false);
  };

  useEffect(() => {
    if (startPrinter) {
      var content = document.getElementById("kotPrintThermal");
      var pri = document.getElementById("kotPrint").contentWindow;
      pri.document.open();
      setTimeout(() => {}, 1000);
      pri.document.write(content.innerHTML);
      pri.document.close();
      pri.focus();
      pri.print();
      setStartPrinter(false);
      form.resetFields();
      clearAll();
    }
  }, [startPrinter]);
  return (
    <>
      {printerLoading && (
        <div className="loading">
          <Loader size={56} />
        </div>
      )}
      <iframe
        id="kotPrint"
        style={{
          height: 0,
          width: 0,
          position: "absolute",
        }}
        title="PRINT"
        // style="height: 0px; width: 0px; position: absolute"
      ></iframe>
      <div
        id="kotPrintThermal"
        style={{
          overflow: "hidden",
          height: "0px",
          position: "absolute",
        }}
      >
        <KopThermalBill
          data={{
            shopName: shopDetails.shopName,
            orderType: form.getFieldValue("orderType"),
            tableNo: form.getFieldValue("tableNo"),
            date: moment().format("DD-MM-YYYY"),
            time: moment().format("hh:mm A"),
            products: addedProducts,
          }}
        />
      </div>
      <Modal
        open={open}
        onCancel={handleClose}
        footer={false}
        centered
        className={classes.modalStyle}
        width={400}
      >
        <h3
          style={{
            color: "#EF4667",
          }}
        >
          Create KOT
        </h3>
        <Divider className={classes.dividerStyle} />
        <Form
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item label="Order Type" name="orderType">
            <Select
              inputProps={{ "aria-label": "Without label" }}
              style={{
                width: "100%",
              }}
              className={classes.selectStyle}
            >
              <MenuItem value={"dine_in"}>Dine In</MenuItem>
              <MenuItem value={"parcel"}>Parcel</MenuItem>
              <MenuItem value={"delivery"}>Delivery</MenuItem>
            </Select>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.orderType !== currentValues.orderType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("orderType") === "dine_in" ? (
                <Form.Item name="tableNo" label="Table Number">
                  <OutlinedInput
                    style={{
                      width: "100%",
                    }}
                    className={classes.selectStyle}
                  />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.orderType !== currentValues.orderType
            }
          >
            {({ getFieldValue }) =>
              getFieldValue("orderType") === "parcel" ? (
                <Form.Item
                  name="parcelNo"
                  label="Parcel Number"
                  // rules={[{ required: true }]}
                >
                  <OutlinedInput
                    style={{
                      width: "100%",
                    }}
                    className={classes.selectStyle}
                  />
                </Form.Item>
              ) : null
            }
          </Form.Item>
          <Form.Item
            label="Waiter Name/Code"
            name="waiterName"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select order type",
            //   },
            // ]}
          >
            <OutlinedInput
              style={{
                width: "100%",
              }}
              className={classes.selectStyle}
            />
          </Form.Item>

          <Divider className={classes.dividerStyle} />
          <div
            style={{
              textAlign: "right",
              marginTop: "8px",
            }}
          >
            <Button size="large" onClick={handleClose} type="link">
              Cancel
            </Button>
            <Button
              size="large"
              htmlType="submit"
              style={{
                marginLeft: "16px",
              }}
              className={classes.ButtonStyle}
            >
              Print
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default AddItemModal;
